import React from "react"
import { TeamMember } from "../types/objects"
import { SectionHeading } from "./ui/SectionHeading"

/**
 * Props interface for Team component
 */
interface TeamProps {
	data?: TeamMember[]
}

/**
 * Team Component — member cards with gradient avatar rings.
 */
export const Team: React.FC<TeamProps> = ({ data = [] }) => {
	return (
		<section id="team" className="lp-section">
			<div className="lp-container">
				<SectionHeading
					eyebrow="Náš tým"
					title={<>Seznamte se s&nbsp;týmem</>}
					lead="Rádi bychom Vám představili náš zkušený tým, který stojí za projekty B2B Technological Insight.
						Martin (Head of Communication) zajišťuje komunikaci a strategii, Michal je technický inženýr
						se zaměřením na návrh architektury a technické audity a Luboš (Financial Director) dohlíží
						na hospodářské operace a ratingy procesů."
				/>

				<div className="lp-team-grid">
					{data.length > 0 ? (
						data.map((member, idx) => (
							<article
								key={`${member.name}-${idx}`}
								className="lp-card lp-card--bar lp-member"
								data-reveal="scale"
								style={{ "--reveal-delay": `${idx * 110}ms` } as React.CSSProperties}
							>
								<div className="lp-member__ring">
									<img src={member.img} alt={member.name} className="lp-member__img" loading="lazy" />
								</div>
								<h3 className="lp-member__name">{member.name}</h3>
								<p className="lp-member__role">{member.job}</p>
							</article>
						))
					) : (
						<p>Načítám členy týmu…</p>
					)}
				</div>
			</div>
		</section>
	)
}
